import {
  ComingSoonWrapper,
  Orb,
  ComingSoonContent,
  Badge,
  BadgeDot,
  ComingSoonTitle,
  ComingSoonSubtitle,
  Dots,
} from './styles';

interface ComingSoonProps {
  title: string;
  description?: string;
}

function ComingSoon({ title, description }: Readonly<ComingSoonProps>) {
  return (
    <ComingSoonWrapper>
      <Orb className="orb-1" />
      <Orb className="orb-2" />
      <Orb className="orb-3" />
      <ComingSoonContent>
        <Badge>
          <BadgeDot />
          Coming Soon
        </Badge>
        <ComingSoonTitle>{title}</ComingSoonTitle>
        <ComingSoonSubtitle>
          {description ??
            'This feature is coming soon and will be available in a future release. We appreciate your patience as we work towards making it available.'}
        </ComingSoonSubtitle>
        <Dots>
          <span />
          <span />
          <span />
        </Dots>
      </ComingSoonContent>
    </ComingSoonWrapper>
  );
}

export default ComingSoon;
